import React, { useEffect } from "react";
import { Button, Modal, Form, Input, message, DatePicker } from "antd";
import API from "../../../../services/api-request";
import TextArea from "antd/es/input/TextArea";
import SelectCompany from "../../../../components/SelectCompany";
import dayjs from "dayjs";

const EditSubscription = (props) => {
  const [editForm] = Form.useForm();

  const onFinish = async (values) => {
    const { company_id, paket, start_date, end_date } = values;

    const dataForm = {
      company_id,
      package: paket,
      start_date,
      end_date,
      id: props.selectedData.id,
    };

    await API.Put(`subscription/${dataForm.id}`, dataForm)
      .then(() => {
        message.success("Subscription has been edited");
        props.onGetSubscription();
        editForm.resetFields();
        props.onShowEdit(false);
      })
      .catch((err) => {
        console.log(err);
        message.info(`${err?.response?.data?.error}`);
      });
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleCancel = () => {
    props.onShowEdit(false);
    editForm.resetFields();
  };

  useEffect(() => {
    editForm.setFieldsValue({
      ...props.selectedData,
      paket: props.selectedData.package,
      start_date: dayjs(props.selectedData.start_date),
      end_date: dayjs(props.selectedData.end_date),
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.selectedData]);

  useEffect(() => {
    if (!props.showEdit) {
      editForm.resetFields();
    }
  }, [props.showEdit]);

  return (
    <>
      <Modal
        title="Edit Subscription"
        open={props.showEdit}
        onCancel={handleCancel}
        footer={[
          <Button key="back" type="default" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={() => editForm.submit()}>
            Save
          </Button>,
        ]}
      >
        <Form
          form={editForm}
          name="Edit Form"
          style={{
            margin: "0 auto",
          }}
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="Select Company"
            name="company_id"
            rules={[{ required: true, message: "Please input name!" }]}
          >
            <SelectCompany />
          </Form.Item>
          <Form.Item
            label="Package"
            name="paket"
            rules={[{ required: true, message: "Please input package!" }]}
          >
            <Input placeholder="Input package" />
          </Form.Item>
          <Form.Item
            label="Start Date"
            name="start_date"
            rules={[{ required: true, message: "Please input Start Date!" }]}
          >
            <DatePicker style={{ width: "100%" }} format="YYYY-MM-DD" />
          </Form.Item>
          <Form.Item
            label="End Date"
            name="end_date"
            rules={[{ required: true, message: "Please input End Date!" }]}
          >
            <DatePicker style={{ width: "100%" }} format="YYYY-MM-DD" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default EditSubscription;
